import * as API from '@/services';
import { prepareContentWithBase64Images } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import {
	formatSystemUseTipDetail,
	formatSystemUseTipList,
} from './system-use-tip.helper';
import { SystemUseTipActions } from './system-use-tip.redux';
import {
	ICreateSystemUseTipRequest,
	IPayloadDeleteSystemUseTipRequest,
	IPayloadGetSystemUseTipDetailRequest,
	IPayloadGetSystemUseTipListRequest,
} from './system-use-tip.type';

export function* getSystemUseTipList(
	action: PayloadAction<IPayloadGetSystemUseTipListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetSystemUseTipListResponse> =
			yield API.getSystemUseTipList({ searchTypes, ...rest });
		const content = formatSystemUseTipList(res?.data?.content);

		yield put(
			SystemUseTipActions.getSystemUseTipListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUseTipActions.getSystemUseTipListFailure());
	}
}

export function* getSystemUseTipDetail(
	action: PayloadAction<IPayloadGetSystemUseTipDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ISystemUseTip> =
			yield API.getSystemUseTipDetail(id);

		const detail = formatSystemUseTipDetail(res.data);

		const content: string = yield prepareContentWithBase64Images(
			detail.content
		);

		yield put(
			SystemUseTipActions.getSystemUseTipDetailSuccess({
				detail: {
					...detail,
					content,
				},
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUseTipActions.getSystemUseTipDetailFailure());
	}
}

export function* createSystemUseTip(
	action: PayloadAction<ICreateSystemUseTipRequest>
) {
	const { callback, data } = action.payload;

	try {
		yield API.createSystemUseTip(data);

		yield put(SystemUseTipActions.createSystemUseTipSuccess());

		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);

		yield put(SystemUseTipActions.createSystemUseTipFailure());
	}
}

export function* deleteSystemUseTip(
	action: PayloadAction<IPayloadDeleteSystemUseTipRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteSystemUseTip(ids);

		yield put(SystemUseTipActions.deleteSystemUseTipSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUseTipActions.deleteSystemUseTipFailure());
	}
}
